<template>
  <v-dialog v-model="dialog" persistent width="300">
    <v-card color="primary" dark>
      <v-card-text class="py-6">
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import UIAccessController from '../assets/js/UIAccessController';

export default {
  data() {
    return {
      dialog: true,
    }
  },
  async created() {
    try {
      const code_verifier = window.localStorage.getItem('code_verifier')

      const response = await fetch(
        `${process.env.VUE_APP_AUTH_ENDPOINT}${process.env.VUE_APP_AUTH_TOKEN}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: `grant_type=authorization_code&code=${this.$route.query.code}&client_id=${process.env.VUE_APP_AUTH_CLIENT_ID}&code_verifier=${code_verifier}`,
        }
      )
      const data = await response.json()

      if (data.error) {
        if (
          data.error === 'invalid_request' ||
          data.error === 'invalid_grant'
        ) {
          window.localStorage.clear()
          this.$router.push({ name: 'LoginIssue' })
        }
      } else {
        this.$store.commit(
          'authentication/SET_REFRESH_TOKEN',
          data.refresh_token
        )
        this.$store.commit('authentication/SET_ACCESS_TOKEN', data.access_token)

        const { admin, employee } = await this.me()

        if (admin) {
          this.$store.commit('authentication/SET_USER', {
            uuid: admin.admin_uuid,
            email: admin.email,
          })
          this.$store.commit('authentication/SET_COMPANY', {
            ...admin.company,
          })

          const [ui_config, my_policies] = await Promise.all([
            this.fetchUiConfig(admin?.company?.company_uuid),
            this.fetchMyPolicies({
              policy_type: 'admin',
              uuid: admin?.admin_uuid,
            }),
          ])

          const uiCtrl = new UIAccessController(admin, ui_config, my_policies)
          this.$store.commit('SET_UI_CTRL', uiCtrl)
        }

        if (employee) {
          this.$store.commit('authentication/SET_USER', {
            uuid: employee.employee_uuid,
            fullName: `${employee.firstname_th} ${employee.lastname_th}`,
            employee_code: employee.employee_code,
          })
          this.$store.commit('authentication/SET_COMPANY', {
            ...employee.company,
          })

          const [ui_config, my_policies] = await Promise.all([
            this.fetchUiConfig(employee?.company?.company_uuid),
            this.fetchMyPolicies({
              policy_type: 'employee',
              uuid: employee?.employee_uuid,
            }),
          ])

          const uiCtrl = new UIAccessController(
            employee,
            ui_config,
            my_policies
          )
          this.$store.commit('SET_UI_CTRL', uiCtrl)
        }

        this.$store.commit(
          'authentication/SET_AUTHENTICATION_STATUS',
          'authenticated'
        )

        sessionStorage.setItem('show-login-announcement', '1')
        this.$router.push({ name: 'Home' })
      }
    } catch (error) {
      window.localStorage.clear()
      this.$router.push({ name: 'LoginIssue' })
    }
  },
  methods: {
    ...mapActions({
      me: 'authentication/me',
      fetchUiConfig: 'authentication/fetchUiConfig',
      fetchMyPolicies: 'authentication/fetchMyPolicies',
    }),
  },
}
</script>
